<template>
  <div class="text-center d-flex flex-column" style="max-width: 550px; gap: 20px">
    <div>
      <article class="icon">
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 11L11 13L15.5 8.5M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </article>
    </div>
    <h2 style="font-weight: 500;">{{ $t('emptyLink.usedLink') }}</h2>
    <h3 class="font-weight-regular text--secondary" v-html="message"></h3>
    <v-btn
      color="primary"
      :href="buttonLink"
      role="button"
      elevation="0"
      v-html="buttonText"
      style="height: 45px; border-radius: 10px;"
    ></v-btn>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
require('@/plugins/OcularMoment')

@Component({
  props: {
    content: {
      type: Object,
      default: null
    }
  }
})
export default class UsedLink extends Vue {
  get buttonLink() {
    return this.content.organization.hostName
  }

  get buttonColor() {
    return this.content.organization.primaryColor ?? 'primary'
  }

  get buttonText() {
    return this.$t('emptyLink.goTo', { name : `${this.content.organization.name}` })
  }

  get message() {
    const companyName = this.content.organization.name
    const expirationDate = this.$ocularMoment.timeZoneDate(this.content.date.endDate).format('DD/MM/YYYY HH:mm')

    return this.$t('emptyLink.message', {
      status: `<b>${this.$t('emptyLink.status.used')}</b>.`,
      company: `<b>${companyName}</b>`,
      additionalInfo: this.$t('emptyLink.additionalInfo.used', { expirationDate: `<b>${expirationDate}</b>` }),
    })
  }
}
</script>

<style scoped>
.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  margin: 0 auto;
}

.icon svg {
  width: 45px;
  fill: none;
  stroke: #000;
  color: #676767;
}
</style>
